import * as Sentry from '@sentry/react';

export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN_FRONTEND;
  if (typeof dsn !== 'string' || dsn.length === 0) {
    // No DSN in this environment (e.g. local dev without observability) — skip init.
    return;
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_APP_ENV ?? 'local',
    tracesSampleRate: 0.1,
    sendDefaultPii: false,
  });
}
